import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmsEngagementModalGraphic = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 152 215",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: -.35273,
			y: .35273,
			width: 109.536,
			height: 208.754,
			rx: 9.64727,
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 109.535 5.51221)",
			fill: "#4D4540",
			stroke: "#4D4540",
			strokeWidth: .705459
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -1,
			y: 1,
			width: 108.242,
			height: 207.459,
			rx: 9,
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 113.754 -8.74228e-08)",
			fill: "white",
			stroke: "#4D4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: -.35273,
			y: .35273,
			width: 30.9194,
			height: 5.165,
			rx: 2.5825,
			transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 75.7438 7.35229)",
			fill: "#4D4540",
			stroke: "#4D4540",
			strokeWidth: .705459
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.6148 67.219C37.1043 67.2324 35.0723 69.2785 35.0762 71.7891L35.1778 136.994C35.1797 138.25 36.1989 139.262 37.4542 139.255L45.0565 139.214V151.265C45.0565 152.173 46.1677 152.611 46.7872 151.948L58.7531 139.141L147.463 138.666C149.974 138.653 152.006 136.606 152.002 134.096L151.904 71.1636C151.9 68.653 149.861 66.6287 147.351 66.6422L39.6148 67.219Z",
			fill: "#B8B8E3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 60.6328,
			y: 82.8389,
			width: 65.8154,
			height: 40.0923,
			rx: 2,
			fill: "#FAC942",
			stroke: "#56569D",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.1243 96.0316L125.393 123.516L62.8552 123.516L94.1243 96.0316Z",
			fill: "#FAC942",
			stroke: "#56569D",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.1237 109.738L62.8546 82.2542L125.393 82.2542L94.1237 109.738Z",
			fill: "#FAC942",
			stroke: "#56569D",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.924,
			y: 73.6541,
			width: 21.0462,
			height: 21.0462,
			rx: 10.5231,
			fill: "#FF2E47"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.693 88.6772V87.4552H127.241V80.6692H127.137L125.031 82.9182L124.134 82.1122L126.448 79.6032H128.684V87.4552H130.894V88.6772H124.693Z",
			fill: "white"
		})
	]
});
export default SvgSmsEngagementModalGraphic;
